import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { ProcessoEnviarDTO, ProcessoSetores, ProcessoSetoresList } from "../../../types/processo/ProcessoSetoresDTO";


const endpointUrl = configUrls.PROCESSO_EP

function enviarProcesso(obj: ProcessoEnviarDTO) {
    return {
        url: `${endpointUrl}/enviar/create`,
        method: "POST",
        body: obj,
    }
}

function cancelarEnvio({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/enviar/${id}`,
        method: "DELETE",
    }
}

function getEnvios({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        
        url: `${endpointUrl}/envios/${id}?search=${search}`,
        method: "GET",
    }
}

function getEnvio(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/enviar/${id}`,
        method: "GET",
    }
}

function deleteEnvio({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/enviar/${id}`,
        method: "DELETE",
    }
}

export const processoEnviarApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({


        getEnvios: query<ProcessoSetoresList[], { id: string, search: string }>({

            query: getEnvios,
            providesTags: ["ProcessoEnviar"],
        }),

        getEnvio: query<ProcessoSetores, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getEnvio,
            providesTags: ["ProcessoEnviar"],
        }),

        enviarProcesso: mutation<void, ProcessoEnviarDTO>(
            {
                query: enviarProcesso,
                invalidatesTags: ["ProcessoEnviar"]
            }),
        deleteEnvio: mutation<void, { id: string }>(
            {
                query: deleteEnvio,
                invalidatesTags: ["ProcessoEnviar"],
            }),


    }),

});
export const {
    useEnviarProcessoMutation,
    useDeleteEnvioMutation,
    useGetEnvioQuery,
    useGetEnviosQuery,
} = processoEnviarApiSlice;
